import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { LanguageState } from 'ia-react-core/~/interfaces/LanguageState';
import compose from 'ia-react-core/~/utils/components/_compose';
import { FC } from 'react';
import ApplicationLayout, { ApplicationLayoutComposedProps, ApplicationLayoutProps } from './ApplicationLayout';

import changeLanguage from '../../actions/fn/changeLanguage';
import get from '../../utils/accessors/get';

export const mapStateToProps = (state: LanguageState) => ({
  locale: get(state, 'language.locale') as string,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchChangeLanguage: (...args: Parameters<typeof changeLanguage>) => dispatch(changeLanguage(...args)),
});

export default compose<FC<ApplicationLayoutProps> & {
  Content: typeof ApplicationLayout.Content;
  Footer: typeof ApplicationLayout.Footer;
  BeforeHeader: typeof ApplicationLayout.BeforeHeader;
  MainHeaderRightContent: typeof ApplicationLayout.MainHeaderRightContent;
  MainHeaderMiddleContent: typeof ApplicationLayout.MainHeaderMiddleContent;
}>(
  connect<ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ApplicationLayoutComposedProps, LanguageState>(mapStateToProps, mapDispatchToProps),
)(ApplicationLayout);

export * from './ApplicationLayout';
